<script>
export default {}
</script>

<template>
  <ul :class="$style.container">
    <img src="@assets/images/Zetrix-Logo.png" alt="Logo" />
  </ul>
</template>

<style lang="scss" module>
@import '@design';

.container {
  height: 80px;
  padding: 0 0 0 88px;
  margin: 0 0;
  text-align: left;
  list-style-type: none;
  background-color: white;
}

@media screen and (max-width: 600px) {
  .container {
    padding: 0 0 0 20px;
  }
}
</style>
